var modules_39642e22 = {"bubble":"_1fqocvv","arrow":"_14xgqkj","container":"_xa0ron","close":"_1ynvgxd","outline-none":"_m8lcju"};
import "../../../assets/Dn7ljfgT.css";

export { modules_39642e22 as default };
//# sourceMappingURL=Tooltip.module.less.js.map
